import './index.css'
import React from 'react'
import useCountdown from 'hooks/use-count-down/index.js'
import formatTimeUnitUtil from 'utils/number/format-time-unit/index.js'
import useSelector from 'hooks/use-selector'
import getDealExpiryDateSelector from 'containers/Deals/selector/get-deal-expiry-date'
import logEventAnalyticsUtil from 'utils/analytics/log-event'

import {
  isMobileScreenUtil
} from 'utils/device'

const ANALYTICS_EVENT = {
  SHOW_DEAL_TIMER_IN_QUICK_SHOP: 'SHOW_DEAL_TIMER_IN_QUICK_SHOP',
  SHOW_DEAL_TIMER_IN_COLLECTION: 'SHOW_DEAL_TIMER_IN_COLLECTION'
}

const SHORT_TEXT = 'Ends:'
const LONG_TEXT = 'Deal ends in'

const DealTimer = (props) => {
  const { variantId } = props
  const endTime = useSelector(getDealExpiryDateSelector(variantId))
  const { isComingFromQuickshop = false, isRelatedProduct = false } = props

  const [days, hours, minutes, seconds] = useCountdown(endTime)
  const isSmallScreen = isMobileScreenUtil()

  const totalHours = (days * 24) + hours
  const formattedHours = formatTimeUnitUtil(totalHours)
  const formattedMinutes = formatTimeUnitUtil(minutes)
  const formattedSeconds = formatTimeUnitUtil(seconds)

  const showShortText = (isSmallScreen && !isComingFromQuickshop) || isRelatedProduct

  React.useEffect(() => {
    if (isComingFromQuickshop) {
      logEventAnalyticsUtil(ANALYTICS_EVENT.SHOW_DEAL_TIMER_IN_QUICK_SHOP)
      return
    }

    logEventAnalyticsUtil(ANALYTICS_EVENT.SHOW_DEAL_TIMER_IN_COLLECTION)
  }, [])

  const formatDoubleDigit = (number) => {
    const str = number.toString()
    return str.length === 1 ? `0${str}` : str
  }

  if (isComingFromQuickshop) {
    return (
      <div className={`deal-timer-container ${showShortText ? '' : 'long-text'}`}>
        <div className='deal-timer-text'>{showShortText ? SHORT_TEXT : LONG_TEXT}</div>
        <div className='timer-boxes'>
          <div className='time-group'>
            {totalHours > 0 && formatDoubleDigit(totalHours).split('').map((digit, idx) => (
              <div key={`hour-${idx}`} className='time-box'>{digit}</div>
            ))}
            <span className='unit-label'>hrs</span>
          </div>
          <div className='time-group'>
            {(totalHours > 0 || minutes > 0) && formatDoubleDigit(minutes).split('').map((digit, idx) => (
              <div key={`min-${idx}`} className='time-box'>{digit}</div>
            ))}
            <span className='unit-label'>min</span>
          </div>
          <div className='time-group'>
            {formatDoubleDigit(seconds).split('').map((digit, idx) => (
              <div key={`sec-${idx}`} className='time-box'>{digit}</div>
            ))}
            <span className='unit-label'>sec</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={`deal-timer-container ${showShortText ? '' : 'long-text'}`}>
      <div className='deal-timer-text'>{showShortText ? SHORT_TEXT : LONG_TEXT}</div>
      <div className='timer-text'>
        {totalHours > 0 && (
          <div className='timer-group'>
            <span className='timer-number'>{formattedHours}</span>
            <span className='unit-label'>hrs</span>
          </div>
        )}
        {(totalHours > 0 || minutes > 0) && (
          <div className='timer-group'>
            <span className='timer-number'>{formattedMinutes}</span>
            <span className='unit-label'>min</span>
          </div>
        )}
        <div className='timer-group'>
          <span className='timer-number'>{formattedSeconds}</span>
          <span className='unit-label'>sec</span>
        </div>
      </div>
    </div>
  )
}

export default DealTimer
